import React from 'react';
import { Button } from '@material-ui/core';
import Image from 'next/image';
import { useRouter } from 'next/router';

import NotFoundImg from '../public/images/404.png';
import { ROUTES } from '../utils/constants';

const NotFound: React.FC = () => {
  const router = useRouter();

  const homepageRouter = () => {
    router.push(`/${ROUTES.DASHBOARD}`);
  };

  return (
    <div className="flex flex-col items-center justify-center h-full p-10 flex-1">
      <div className="mb-6">
        <Image src={NotFoundImg} alt="Not Found Image" />
      </div>
      <p className="font-bold mt-2 mb-1 text-2xl leading-9">
        Oops! Page Not Found
      </p>
      <p
        className="font-bold mb-2 text-base text-center"
        style={{ color: '#4A4A4E' }}
      >
        Sorry, the page you were looking for doesn&apos;t exist
      </p>
      <div className="mt-6">
        <Button
          color="primary"
          variant="contained"
          disableRipple
          disableElevation
          onClick={homepageRouter}
          style={{
            textTransform: 'capitalize',
            padding: '10px 23px',
            borderRadius: '.5rem',
          }}
        >
          Go to Homepage
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
